import React from 'react';
import styled from 'styled-components';
import { Bio } from '../../data/constants';
import { SubTitle, ResumeButton } from './AboutStyle'; 

const Container = styled.div`
  text-align: center; 
  margin-top:10px;
`;
const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1550px;
  padding: 80px 0;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const Heading = styled.h1`
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 40px;
  margin-top:0px;
  color: ${({ theme }) => theme.text_primary};
   @media (max-width: 960px) {
    font-size: 32px;
  }

`;

const About = () => {
  return (
    
    <Container id='about'>
      <Wrapper>
      <Heading>About</Heading>
      <SubTitle>{Bio.description}</SubTitle>
      <ResumeButton href={Bio.resume} target='_blank'>Check Resume</ResumeButton>
      </Wrapper>
    </Container>
    
  );
};

export default About;
